module.exports = __webpack_public_path__ + "842b81b8b2efda3135403ce460eed4a3.webp";